import { extend } from 'quasar'
import { get } from 'lodash'

export default class VuexDataBindingHelper {
  constructor (vuexData, fields, additionalProperties = {}) {
    this.original = vuexData
    this.additionalProperites = additionalProperties
    this.data = extend(true, {}, vuexData, additionalProperties)
    this.fields = fields
  }

  /**
   * Get the fields that are different from the original data.
   * @returns {Array}
   */
  getDirtyFields () {
    let dirtyFields = []

    this.fields.forEach((field) => {
      let key = _getKey(field)

      let data = get(this.data, key, 'undefined')
      let original = get(this.original, key, 'undefined')
      let additional = get(this.additionalProperites, key, 'undefined')

      if (original === 'undefined' && additional !== 'undefined' && data !== additional) {
        dirtyFields.push(field)
      } else if (original !== 'undefined' && data !== original) {
        dirtyFields.push(field)
      }
    })

    return dirtyFields
  }

  /**
   * Checks if a given field has changed.
   * @param field
   * @returns {boolean}
   */
  isDirty (field) {
    return this.getDirtyFields().indexOf(field) !== -1
  }

  /**
   * Get the data that has changed.
   * @returns {{}}
   */
  getChangedData () {
    let obj = this.data
    let changedData = {}

    this.fields.forEach((field) => {
      let key = _getKey(field)

      if (this.isDirty(field)) {
        let identifier = _getIdentifier(field)
        changedData[identifier] = get(obj, key)
      }
    })

    return changedData
  }

  /**
   * Sets the data to the original data.
   */
  reset () {
    this.data = this.original
  }
}

/**
 * Helper function to get the key of a field.
 * @param field
 * @returns {string}
 * @private
 */
function _getKey (field) {
  if (typeof field === 'object') {
    return field.key
  } else if (typeof field === 'string') {
    return field
  } else {
    throw new Error('Could not parse field')
  }
}

function _getIdentifier (field) {
  if (typeof field === 'object') {
    return field.as
  } else if (typeof field === 'string') {
    return field
  } else {
    throw new Error('Could not parse field')
  }
}
